import { Mail } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { PunchupConfirmDialog } from 'features/common/components/Punchup/composites/dialogs/PunchupConfirmDialog';

interface ResendModalProps {
	onConfirm: () => void;
	onClose: () => void;
	isLoading: boolean;
}

export const ResendModal: FC<ResendModalProps> = ({ onConfirm, onClose, isLoading }) => {
	const { t } = useTranslation();
	return (
		<PunchupConfirmDialog
			icon={<Mail size={24} />}
			title={t('attendee-actions-resend-ticket', 'Resend Order Email')}
			text={t(
				'attendee-actions-resend-body',
				"A copy of this order's confirmation email will be sent to the buyer. All tickets in the order are included — one send is enough."
			)}
			secondaryText={t(
				'attendee-actions-resend-secondary',
				"The email is sent to the buyer's registered address and, when a name is on file, is addressed to them personally. All tickets belonging to this specific order are bundled in one email: if Bob purchased three tickets in a single order, one resend delivers all three. If Caroline placed two separate orders, resending from any attendee row sends only the confirmation for that particular order."
			)}
			collapsibleSecondary
			isLoading={isLoading}
			buttons={[
				{ label: t('cancel', 'Cancel'), variant: 'secondary', onClick: onClose },
				{ label: t('send', 'Send'), variant: 'primary', onClick: onConfirm },
			]}
		/>
	);
};
